"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var useStyle = (0, _styles.makeStyles)(function (theme) {
  var _root;

  return {
    root: (_root = {
      alignItems: 'center',
      backgroundColor: '#fafbfc',
      display: 'flex',
      justifyContent: 'center',
      overflow: 'hidden',
      minHeight: '100%',
      minWidth: 514,
      width: 514,
      position: 'relative'
    }, _defineProperty(_root, theme.breakpoints.down('md'), {
      minWidth: 435,
      width: 435
    }), _defineProperty(_root, theme.breakpoints.down('sm'), {
      minHeight: 'auto',
      minWidth: 'auto',
      width: '100%'
    }), _root)
  };
});

var Focal = function Focal(_ref) {
  var children = _ref.children,
      focalBackground = _ref.focalBackground;
  var cls = useStyle();
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    component: "div",
    className: cls.root,
    style: focalBackground
  }, children);
};

Focal.defaultProps = {
  focalBackground: {}
};
Focal.propTypes = {
  children: _propTypes["default"].node.isRequired,
  focalBackground: _propTypes["default"].objectOf(_propTypes["default"].string)
};
var _default = Focal;
exports["default"] = _default;